<template>
  <div class="inputs">
    <input
      v-for="i in 6"
      :key="i"
      v-model="code[i - 1]"
      @input="handleInput($event)"
      @paste="handleInputPaste($event)"
      @keydown="handleInputKeydown($event)"
      @focus="handleInputFocus($event)"
      type="tel"
      maxlength="1"
      pattern="[0-9]"
      placeholder="•"
    />
  </div>
</template>
<script>
export default {
  name: "CodeVerificationInputs",
  data() {
    return {
      code: ["", "", "", "", "", ""]
    };
  },
  computed: {},
  watch: {
    code: function(val) {
      this.$emit("code", val);
    }
  },
  methods: {
    handleInput(e) {
      const input = e.target;
      const nextInput = input.nextElementSibling;
      if (nextInput && input.value) {
        nextInput.focus();
        if (nextInput.value) {
          nextInput.select();
        }
      }
    },
    handleInputFocus(e) {
      setTimeout(() => {
        e.target.select();
      }, 0);
    },
    handleInputPaste(e) {
      e.preventDefault();
      const inputs = document.querySelectorAll("code-inputs");
      const paste = e.clipboardData.getData("text");
      inputs.forEach((input, i) => {
        input.value = paste[i] || "";
      });
    },
    handleInputKeydown(e) {
      const KEYBOARDS = {
        backspace: 8,
        arrowLeft: 37,
        arrowRight: 39
      };
      switch (e.keyCode) {
        case KEYBOARDS.backspace:
          this.handleBackspace(e);
          break;
        case KEYBOARDS.arrowLeft:
          this.handleArrowLeft(e);
          break;
        case KEYBOARDS.arrowRight:
          this.handleArrowRight(e);
          break;
        default:
      }
    },
    handleBackspace(e) {
      const input = e.target;
      if (input.value) {
        input.value = "";
        return;
      }
      if (input.previousElementSibling) {
        console.log("not first input");
        input.previousElementSibling.focus();
      } else {
        input.value = "";
        console.log("first input");
      }
    },
    handleArrowLeft(e) {
      const previousInput = e.target.previousElementSibling;
      if (!previousInput) return;
      previousInput.focus();
    },
    handleArrowRight(e) {
      const nextInput = e.target.nextElementSibling;
      if (!nextInput) return;
      nextInput.focus();
    }
  }
};
</script>
<style lang="scss" scoped>
.inputs {
  //margin-top: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  //padding: 9px;
  input {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 42px;
    height: 42px;
    border: none;
    /* BG/type1 */
    background: $bg-type-1;
    border-radius: 10px;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 6px;
    text-align: center;
    /* 16/SemiBold */
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    /* Text/type0 */
    color: $text-type-0;
    &:focus {
      outline: 0;
    }
    &:focus-within {
      border: 2px solid $text-type-2;
    }
    &::placeholder {
      color: $text-type-2;
      /* 14/Regular */
      font-weight: bold;
      font-size: 24px;
    }
  }
}
</style>
